import { store } from "@/stores/store";
import { openSelectBrandDialog } from "@/components/header/dialogs/SelectBrandDialog.vue";
import SelectBrandDialog from "./dialogs/SelectBrandDialog.vue";
export default {
  name: "HeaderBrand",
  data: function data() {
    return {
      store: store
    };
  },
  methods: {
    open: function open() {
      openSelectBrandDialog();
    }
  },
  components: {
    SelectBrandDialog: SelectBrandDialog
  }
};